import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function ArticleDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch((e) => setErr(formatApiError(e))).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="text-stone-500" data-testid="article-loading">Loading…</div>;
  if (err) return <div className="text-destructive" data-testid="article-error">{err}</div>;
  if (!article) return null;

  return (
    <article className="fade-in max-w-[70ch] mx-auto" data-testid="article-detail">
      <Link to="/articles" className="inline-flex items-center gap-1 text-sm text-stone-600 hover:text-primary mb-6">
        <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> All articles
      </Link>

      {article.image_url && (
        <div className="mb-8 rounded-md overflow-hidden border border-stone-200">
          <img src={article.image_url} alt={article.title} className="w-full h-64 object-cover" />
        </div>
      )}

      <div className="text-xs uppercase tracking-[0.2em] text-primary/80 font-medium mb-3">Article</div>
      <h1 className="font-serif text-4xl sm:text-5xl text-stone-900 leading-tight">{article.title}</h1>
      <div className="mt-3 text-stone-500 text-sm">
        {article.author ? <span>By {article.author} · </span> : null}
        {new Date(article.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
      </div>

      <div className="mt-8 scripture whitespace-pre-wrap" style={{ fontSize: "1.15rem", lineHeight: 1.85 }} data-testid="article-body">
        {article.body}
      </div>
    </article>
  );
}
